module.exports = __webpack_public_path__ + "static/media/canal_box.b212594b.png";